<template>
    <div class="my-4 border-2">
        <div v-for="(site, index) in data.sites" class="my-4">
            <form
                :action="route('api.bonusLists.update-all', [site])"
                method="POST"
                class="mb-2"
            >
                <input type="hidden" name="_token" :value="csrf"/>
                <Btn :key="`site-${index}`"
                     :content="`Update Bonus Lists for ${site.domain}`"
                     :disabled-content="`Updating Bonus Lists for ${site.domain}`"
                     :disabled="site.isUpdateDisabled"
                />
            </form>

            <p v-if="site.bonus_list_update_last_run" class="text-blue-600 dark:text-blue-300">
                <span class="font-bold">⏰ Last manual update:</span> {{ site.bonus_list_update_last_run }}
            </p>

            <p v-if="site.updateCompleted" :key="`site-${index}`" class="text-green-600 dark:text-green-300">
                <span class="font-bold">🎉 {{ site.domain }}</span> bonus lists has been updated!
            </p>

            <p v-if="site.updateFailed" :key="`site-${index}`" class="text-red-600 dark:text-red-300">
                😢 There was an error
            </p>
        </div>
    </div>
</template>

<script>
import csrf from '../mixins/csrf'

export default {
    name: 'UpdateBonusLists',
    mixins: [csrf],
    props: {
        sites: Array,
    },
    data() {
        return {
            data: {sites: []},
        }
    },
    mounted: function () {
        this.data = this.updateDefaultData(this.sites);

        for (let i = 0; i < this.data.sites.length; i++) {
            if (this.data.sites[i].isUpdateDisabled) {
                this.checkUpdateProgress(i);
            }
        }
    },
    methods: {
        checkUpdateProgress: function (siteIndex) {
            const check = setInterval(() => {
                axios
                    .get(route('api.bonusLists.update-all-status', [this.data.sites[siteIndex]]))
                    .then((response) => {
                        if (response.data.status === 'completed') {
                            Object.assign(this.data.sites[siteIndex], {isUpdateDisabled: false});
                            Object.assign(this.data.sites[siteIndex], {updateCompleted: true});
                            Object.assign(this.data.sites[siteIndex], {updateFailed: false});

                            clearInterval(check)
                        }

                        if (
                            response.data.status !== 'completed' &&
                            response.data.status !== 'in_progress'
                        ) {
                            Object.assign(this.data.sites[siteIndex], {isUpdateDisabled: false});
                            Object.assign(this.data.sites[siteIndex], {updateCompleted: false});
                            Object.assign(this.data.sites[siteIndex], {updateFailed: true});

                            clearInterval(check)
                        }
                    })
                    .catch((error) => {
                        console.error(error)

                        Object.assign(this.data.sites[siteIndex], {isUpdateDisabled: false});
                        Object.assign(this.data.sites[siteIndex], {updateCompleted: false});
                        Object.assign(this.data.sites[siteIndex], {updateFailed: true});

                        clearInterval(check)
                    })
            }, 15000)
        },
        updateDefaultData(sites) {
            return {
                sites: this.updateDefaultSites(sites),
            }
        },
        updateDefaultSites(sites) {
            for (let i = 0; i < sites.length; i++) {
                if (sites[i].bonus_list_update_status == null) {
                    Object.assign(sites[i], {isUpdateDisabled: false});
                    Object.assign(sites[i], {updateCompleted: false});
                    Object.assign(sites[i], {updateFailed: false});
                }
                else if (sites[i].bonus_list_update_status === 'completed') {
                    Object.assign(sites[i], {isUpdateDisabled: false});
                    Object.assign(sites[i], {updateCompleted: true});
                    Object.assign(sites[i], {updateFailed: false});
                }
                else if (sites[i].bonus_list_update_status === 'in_progress') {
                    Object.assign(sites[i], {isUpdateDisabled: true});
                    Object.assign(sites[i], {updateCompleted: false});
                    Object.assign(sites[i], {updateFailed: false});
                }
                else if (
                    sites[i].bonus_list_update_status !== 'completed' &&
                    sites[i].bonus_list_update_status !== 'in_progress'
                ) {
                    Object.assign(sites[i], {isUpdateDisabled: false});
                    Object.assign(sites[i], {updateCompleted: false});
                    Object.assign(sites[i], {updateFailed: true});
                }
            }

            return sites;
        },
    },
}
</script>
